import * as React from 'react';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';

import Orders from '../components/Query/Orders/Orders';
import { getClassForStatus } from '../helpers/orders/getClassForStatus';
import { Button, Container, Loader, Section, Title } from '../modules/modules';
import { CurrencyFormatter as Currency } from '../utils/utils';
import UserWrap from '../components/UserWrap';
import { getLastInvoice } from '../helpers/invoices/getLastInvoice';
import { url } from '../config';
import CountryService from '../services/CountryService';
import { hasInvoice as orderHasInvoice } from '../helpers/orders/hasInvoice';
import { callAuthorizeBackend } from '../helpers/backend/callAuthorizeBackend';
import FlashStore from '../services/FlashStore';

interface IOrderListState {
  showAll: boolean;
}

interface IOrderListProps extends RouteComponentProps<{ language: string }> { }

class OrderList extends React.Component<IOrderListProps> {

  private first = 5;

  public state: IOrderListState;

  constructor(props: IOrderListProps) {
    super(props);

    this.state = {
      showAll: false
    };
  }

  private downloadInvoice(orderNo: string) {
    this.setState({
      generating: true,
    }, () => {
      callAuthorizeBackend({
        path: `/invoices/generate?order=${orderNo}`,
        method: 'GET',
        executeDownload: true,
        onSuccess: () => {
          this.setState({
            generating: false
          });
        },
        onError: (e) => {
          FlashStore.GetInstance().showMessage('Downloading invoice failed');
          this.setState({
            generating: false
          });
        }
      });
    });
  }

  public render() {
    const { language, countryCode } = CountryService.GetInstance();

    return (
      <main>
        <Section type="userPage">
          <UserWrap>

            <Title type="lower">Orders</Title>
            <table className="table ordersTable bordered mt-3" style={{ border: 1 }}>
              <thead>
                <tr>
                  <th className={'ordersTable__number'}>Number</th>
                  <th className={'ordersTable__createdAt'}>Date</th>
                  <th className={'ordersTable__price'}>Price</th>
                  <th>Status</th>
                  <th>Invoice</th>
                </tr>
              </thead>
              <tbody>
                <Orders first={this.state.showAll ? undefined : this.first}>
                  {({ orders }: any) => {
                    if (orders.loading) {
                      return (
                        <tr>
                          <td colSpan={4}>
                            <Loader />
                          </td>
                        </tr>
                      );
                    }

                    return orders.orderHistory.map((o: GQL.IOrder) => {
                      return (
                        <tr key={o.id}>
                          <td className={'ordersTable__number'}>
                            <Link
                              // Country code urls are not used anymore
                              // to={`/${countryCode}/user/orders/detail/${o.orderNumber}`}
                              to={`/user/orders/detail/${o.orderNumber}`}
                              className="link"
                              style={{
                                textDecoration: 'underline'
                              }}
                            >
                              {o.orderNumber}
                            </Link>
                          </td>
                          <td className={'ordersTable__createdAt'}>
                            {new Date(o.createdAt).toLocaleDateString()}
                          </td>
                          <td className={'ordersTable__price'}>
                            <b>
                              <Currency price={o.grandTotal} currency={o.currency || undefined} />
                            </b>
                          </td>
                          {o.externalState && 
                            <td className={`${getClassForStatus(o.externalState)}`}>
                              {o.externalState.name[language] || '-'}
                            </td> || <td>&nbsp;</td>}
                          <td>
                            {orderHasInvoice(o) && <Link
                             to={'#'}
                             onClick={() => this.downloadInvoice(o.orderNumber)}
                            >
                              Download
                            </Link> || <span>&nbsp;</span>}
                          </td>
                        </tr>
                      );
                    });
                  }}
                </Orders>
              </tbody>
            </table>

            <div className="text-center mt-5">
              {!this.state.showAll && (
                <Button onClick={() => this.setState({ showAll: true })} color="trans" size="lg">
                  Display all
                </Button>
              )}
            </div>
          </UserWrap>
        </Section>
      </main>
    );
  }
}

export default withRouter(OrderList);



// WEBPACK FOOTER //
// ./src/pages/OrderList.tsx